import React from 'react';
import { Box, Heading, Text, Stack, Center } from '@chakra-ui/react';

const DashboardCoordinador = () => {
  return (
    <Center minH="76vh" bg="gray.50" _dark={{ bg: 'gray.900' }}>
      <Box
        p={8}
        borderRadius="xl"
        boxShadow="lg"
        bg="white"
        _dark={{ bg: 'gray.800' }}
        maxW="lg"
        w="full"
      >
        <Stack spacing={4} align="center">
          <Heading as="h1" size="xl" color="primary.500" _dark={{ color: 'primary.200' }}>
            Bienvenido Coordinador
          </Heading>
          <Text fontSize="lg" color="gray.600" _dark={{ color: 'gray.300' }}>
            Este es el panel principal de coordinación. Aquí podrás gestionar y visualizar la información relevante del sistema.
          </Text>
        </Stack>
      </Box>
    </Center>
  );
};

export default DashboardCoordinador;